import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import { studioApi } from "services/studioService";

/* The Preview tab.

   Before the app's own Firebase project exists, the QUICK preview is served by
   the Studio service and sandboxed with no same-origin: pages render, but
   sign-in and saved data are off. Once the project is ready, the preview
   CHANNEL runs on the app's own web.app address, with its own preview
   database, so sign-up and data work. Either way the client's code never runs
   on codenec.ai: the frame is always another origin.

   No allow-top-navigation in either sandbox: nothing in the preview can move
   the Studio page itself.

   Without a paid plan (the trial, or a plan that ended) the app has no
   project of its own, so only the quick preview exists, and its help says so. */

const QUICK_SANDBOX = "allow-scripts allow-forms allow-popups allow-modals";
const CHANNEL_SANDBOX = "allow-scripts allow-forms allow-same-origin allow-popups allow-modals";

function StudioPreview({ project, quickPreviewPath, plan = null }) {
  const { t } = useTranslation();
  const [reloadKey, setReloadKey] = useState(0);

  const channelReady = project.status === "ready" && project.previewUrl && project.previewVersion;
  const src = channelReady ? project.previewUrl : quickPreviewPath ? studioApi.previewUrl(quickPreviewPath) : null;
  const behind = channelReady && project.previewVersion < project.currentVersion;
  const quickOnly = plan ? !plan.canCreateGoogleProject : false;

  return (
    <div className="studio-tab-body">
      <div className="studio-preview-bar">
        <span className="studio-chip">{channelReady ? t("studio.preview.full") : t("studio.preview.quick")}</span>
        <span>
          {channelReady
            ? behind
              ? t("studio.preview.updating")
              : t("studio.preview.fullHelp", { n: project.previewVersion })
            : quickOnly
              ? t("studio.preview.trialHelp")
              : t("studio.preview.quickHelp")}
        </span>
        <span className="studio-bar__spacer" />
        <button type="button" className="studio-btn studio-btn-ghost studio-btn-small" onClick={() => setReloadKey((k) => k + 1)}>
          {t("studio.preview.reload")}
        </button>
        {src && (
          <a href={src} target="_blank" rel="noopener noreferrer">{t("studio.preview.openTab")}</a>
        )}
      </div>
      {project.previewErrorCode && (
        <div className="studio-notice" style={{ margin: 12 }}>
          <p>{t(`studio.preview.errors.${project.previewErrorCode}`, { defaultValue: project.previewError })}</p>
        </div>
      )}
      {src ? (
        <iframe
          key={`${src}-${project.previewVersion ?? project.currentVersion}-${reloadKey}`}
          className="studio-preview-frame"
          title={t("studio.preview.title")}
          src={src}
          sandbox={channelReady ? CHANNEL_SANDBOX : QUICK_SANDBOX}
          referrerPolicy="no-referrer"
        />
      ) : (
        <div className="studio-scroll studio-muted">{t("studio.common.loading")}</div>
      )}
    </div>
  );
}

export default StudioPreview;
